import styled from 'styled-components'
import { Spacing } from '@doordash/design-language'

export const StyledUl = styled.ul`
  padding-inline-start: ${Spacing.Large}px;
`
